import { render, staticRenderFns } from "./FilterSourcesEditor.vue?vue&type=template&id=44ed54a8&scoped=true&"
import script from "./FilterSourcesEditor.vue?vue&type=script&lang=js&"
export * from "./FilterSourcesEditor.vue?vue&type=script&lang=js&"
import style0 from "./FilterSourcesEditor.vue?vue&type=style&index=0&id=44ed54a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ed54a8",
  null
  
)

export default component.exports